var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-2 px-1"},[_c('span',{staticClass:"titulo-info font-size-1 text-semibold text-uppercase"},[_vm._v(_vm._s(_vm.aItems.Pregunta))])])
}
var staticRenderFns = []

export { render, staticRenderFns }